import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import { Subscribe } from "unstated";
import * as DOMPurify from 'dompurify';
import InvoiceDataContainer from "../../Stores/InvoiceDataContainerStore";
import { myGlobals, myUtilities } from "../../Utils";
import cross from "../../Images/cross.png";
import InvoiceCompleteGrid from "./InvoiceCompleteGrid";

class InvoiceCompleteGridHeader extends React.Component {
  displayHeaders = () => {
    let fields = this.props.fields;
    let columns = new Array();
    if (fields !== undefined) {
      for (let i = 0; i < fields.length; ++i) {
        if (fields[i][0] !== undefined && fields[i][1] !== undefined) {
          columns.push(
            <td style={{ minWidth: '115px', padding:'2px' }}>
              {myUtilities.accountSpecificLanguage(
                "invoicegrid.header.label." + DOMPurify.sanitize(fields[i][0]),
                DOMPurify.sanitize(fields[i][1])
              )}
            </td>
          );
        }
      }
    }
    return columns;
  };
  crossOnClick = () => {
    this.props.crossClick(false);
  };
  render() {
    return (
      <Subscribe to={[InvoiceDataContainer]}>
        {(data) => (
          <Container className="complete-invoice-grid-header">
            <div
              className="view-more-close-button-container"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div>
                <b>
                  {myUtilities.accountSpecificLanguage(
                    "Header.PaySelectedBills",
                    "Pay Selected Bills"
                  )}
                </b>
              </div>
              <div>
                <img src={cross} onClick={this.crossOnClick} />
              </div>
            </div>
            <div className="invoiceTableGrid">
              <table style={{ width: "100%"}}>
                <tr
                  onClick={() => data.toggleSelctedInvoices()}
                  className="view-more-header"
                >
                  <td>
                      <div>
                        <input
                          checked={
                            data.state.selectedInvoices.length ===
                            data.state.invoices.length
                          }
                          type="checkbox"
                          value="1"
                          id="checkboxOneInput"
                          name=""
                        />
                        <label for="checkboxOneInput"></label>
                      </div>
                  </td>
                  {this.displayHeaders()}
                </tr>

                <InvoiceCompleteGrid />
                {/* </div> */}
              </table>
            </div>
          </Container>
        )}
      </Subscribe>
    );
  }
}

export default InvoiceCompleteGridHeader;
